import { render } from "./coin-history-header.html?vue&type=template&id=240d0194&scoped=true&ts=true"
import script from "./coin-history-header.vue?vue&type=script&lang=ts"
export * from "./coin-history-header.vue?vue&type=script&lang=ts"

import "./coin-history-header.scss?vue&type=style&index=0&id=240d0194&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240d0194"]])

export default __exports__